import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { MotionDiv } from '@/components/element/MotionDiv';
import { Link } from 'react-router-dom';
import { PlDataElement } from '@/features/w/[identifier]/finance/finance_exports/{components}/PlDataElement';
import { FinanceDataElement } from '@/features/w/[identifier]/finance/finance_exports/{components}/FinanceDataElement';

export const FinanceExports = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('データエクスポート'), []);
  useEffect(() => setBreadcrumbs([]), []);

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MotionDiv className="row">
          <div className="col-md-6">
            <PlDataElement />
          </div>
          <div className="col-md-6">
            <FinanceDataElement />
          </div>
        </MotionDiv>
      </div>
    </WorkspaceLayout>
  );
};
